import { API_URL } from '../../../../constants';

const paths = {
  getMyCard: (): string => `${API_URL}/my-employee-card`,
  getMyAppleWalletEmployeeCard: (): string => `${API_URL}/apple-wallet-employee-card`,
  addToGoogleWallet: (): string => `${API_URL}/google-wallet-employee-card`,
};

export default paths;
